import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
 * 获取消防报警
 */
export function fireProtectionSystemSummaryOfFloor(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/devicemap/fireProtectionSystemSummaryOfFloor',
        method: 'get',
        params
    })
}

/**
 * 获取报警类型
 */
 export function fireProtectionSystemSummaryOfType(params) {
  return request({
      url: envInfo.bgApp.basePath + '/tenant/devicemap/fireProtectionSystemSummaryOfType',
      method: 'get',
      params
  })
}

/**
 * 电梯状态
 */
 export function queryLiftDetail(params) {
  return request({
      url: envInfo.bgApp.attendancePath + '/elevator/queryLiftDetail',
      method: 'get',
      params
  })
}

/**
 * 信息发布 设备列表
 */
 export function informationDeviceList(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/door/informationDeviceList',
        method: 'post',
        data: params
    })
}

/**
 * 信息发布 设备状态
 * @param（*） deviceId 设备ID
 */
export function informationDeviceStatus(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/door/informationDeviceStatus',
        method: 'get',
        params
        
    })
}
  
/**
 * 信息发布 设备列表
 * @param（string） deviceId 设备ID
 * @param（int） state 状态
 */
 export function informationDeviceSwitch(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/door/informationDeviceSwitch',
        method: 'get',
        params
    })
}

  /**
 * 信息发布 设备列表
 * @param（string） deviceId 设备ID
 * @param（int） state 状态
 */
 export function getLatestLiftRunStatistics(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/elevator/getLatestLiftRunStatistics',
        method: 'post',
        data: params
    })
}

/**
 * 停车场
 * @param（string） queryDate 时间范围
 * 
 */
   export function parkingAreaStatistics(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/devicemap/parkingAreaStatistics',
        method: 'get',
        params
    })
}

/**
 * 停车场
 * @param（string） queryDate 时间范围
 * 
 */
 export function parkingAreaOccupancyNum(params) {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/devicemap/parkingAreaOccupancyNum',
        method: 'get',
        params
    })
}

/**
 * 根据设备ID获取数据
 * @param（string） deviceId 设备id
 * 
 */
export function getDeviceContent( deviceId ) {
    return request({
      url: envInfo.bgApp.basePath + '/tenant/devicemap/deviceContent/' + deviceId,
      method: 'get',
    })
}
  
/**
 * 开关屏设置
 */
 export function submitsystemscreen(params) {
    return request({
        url: envInfo.bgApp.basePath + '/client/postClient',
        method: 'post',
        data:params
    })
}


/**
 * 开关机设置
 */
export function submitsystempower(params) {
    return request({
        url: envInfo.bgApp.basePath + '/client/postClient',
        method: 'post',
        data:params
    })
}

/**
 * 首页看板 - 运行数据
 */
 export function deviceOperationData() {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/devicemap/deviceOperationData',
        method: 'get'
    })
}

/**
 * 首页看板 - 设备监控,设备数量统计
 */
 export function deviceQuantityStatistics() {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/devicemap/deviceQuantityStatistics',
        method: 'get'
    })
}

// saas/attendance/elevator/getRecordvideoAuthorization
/**
 * 首页看板 - 设备监控,设备数量统计
 */
 export function getRecordvideoAuthorization(params) {
    return request({
        url: envInfo.bgApp.attendancePath + '/elevator/getRecordvideoAuthorization',
        method: 'get',
        params
    })
}